import { get } from "lodash";
import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import { FileUploadComponent } from "./FileUploadComponent";

interface FileUploadProps {
  name: string;
  rules: RegisterOptions;
}

export const FileUpload = ({
  name,
  rules,
  ...passThroughProps
}: FileUploadProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);
  const errorMessage = typeof error?.message === "string" ? error.message : "";
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange } }) => (
        <FileUploadComponent
          {...passThroughProps}
          name={name}
          onChange={onChange}
          errorMessage={errorMessage}
        />
      )}
    />
  );
};
